// extracted by mini-css-extract-plugin
module.exports =  {"root":"PtxnJPFMTX5NfoBHKVpb"};